// extracted by mini-css-extract-plugin
export default {"tableRow":"violationList_tableRow__OR97v","tableCell":"violationList_tableCell__SxApg"};